module.exports = __webpack_public_path__ + "img/教育4.816b35c3.png";